import { MIME_TYPE_MERGE_PATCH_JSON } from "@rumble-it/common-lib/src/constants/mimeTypes";
import { CollectionResponse } from "@rumble-it/common-lib/types/api/CollectionResponse.interface";
import { ServicePartner } from "@rumble-it/common-lib/types/models/ServicePartner.interface";
import { axiosInstance } from "../client";

type RootServicePartnerAddressDto = {
  street: string;
  streetNumber: string;
  streetNumberAddition: string | null;
  postalCode: string;
  city: string;
  country: string;
};

export type RootServicePartnerUpdateDto = Partial<{
  name: string;
  groupName: string | null;
  email: string | null;
  telephone: string | null;
  website: string | null;
  dwproAudaboxNumber: number | null;
  externalReference: string | null;
  address: RootServicePartnerAddressDto | null;
  postalAddress: RootServicePartnerAddressDto | null;
}>;

export type RootServicePartnerCreateDto = {
  name: string;
} & Partial<{
  groupName: string | null;
  email: string | null;
  telephone: string | null;
  website: string | null;
  dwproAudaboxNumber: number | null;
  externalReference: string | null;
  address: RootServicePartnerAddressDto | null;
  postalAddress: RootServicePartnerAddressDto | null;
}>;

export const fetchRootServicePartners = async (): Promise<
  CollectionResponse<ServicePartner>
> => {
  const member: ServicePartner[] = [];
  let page = 1;
  for (;;) {
    const { data } = await axiosInstance.get<
      CollectionResponse<ServicePartner>
    >("/service-partners", {
      isRootRequest: true,
      params: { page, itemsPerPage: 1000 },
    });
    member.push(...data.member);
    if (member.length >= data.totalItems || data.member.length === 0) {
      return { ...data, member };
    }
    page += 1;
  }
};

export const fetchRootServicePartnerById = async (
  id: string,
): Promise<ServicePartner> =>
  axiosInstance
    .get(`/service-partners/${id}`, { isRootRequest: true })
    .then((response) => response.data);

export const createRootServicePartner = async (
  data: RootServicePartnerCreateDto,
): Promise<ServicePartner> =>
  axiosInstance
    .post(`/service-partners`, data, { isRootRequest: true })
    .then((response) => response.data);

export const updateRootServicePartner = async (
  id: string,
  data: RootServicePartnerUpdateDto,
): Promise<ServicePartner> =>
  axiosInstance
    .patch(`/service-partners/${id}`, data, {
      isRootRequest: true,
      headers: { "Content-Type": MIME_TYPE_MERGE_PATCH_JSON },
    })
    .then((response) => response.data);
